import { render, staticRenderFns } from "./ReadonlyFormModosComponent.vue?vue&type=template&id=d2441302"
import script from "./ReadonlyFormModosComponent.vue?vue&type=script&lang=js"
export * from "./ReadonlyFormModosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports